"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _defaultTheme = _interopRequireDefault(require("../../defaultTheme"));
var _mediaQuery = _interopRequireDefault(require("../mediaQuery"));
var _consts = require("../mediaQuery/consts");
var _getViewportGridStyles = _interopRequireDefault(require("./helpers/getViewportGridStyles"));
var _layout = require("../layout");
const StyledGrid = _styledComponents.default.div.withConfig({
  displayName: "Grid__StyledGrid",
  componentId: "sc-9xttzw-0"
})(["", ";"], ({
  theme,
  ...props
}) => Object.values(_consts.DEVICES).map(viewport => viewport in _mediaQuery.default ? _mediaQuery.default[viewport]((0, _styledComponents.css)(["", ";"], (0, _layout.isDefined)(props[viewport]) && (0, _getViewportGridStyles.default)({
  viewport,
  theme
}))) : viewport === "smallMobile" && (0, _styledComponents.css)(["", ";"], (0, _getViewportGridStyles.default)({
  viewport,
  theme
}))));
StyledGrid.defaultProps = {
  theme: _defaultTheme.default
};
const Grid = ({
  inline,
  rows = "1fr",
  columns = "1fr",
  gap,
  rowGap,
  columnGap,
  maxWidth,
  width,
  spaceAfter,
  children,
  dataTest,
  as = "div",
  ...props
}) => {
  const smallMobile = {
    inline,
    rows,
    columns,
    gap,
    rowGap,
    columnGap,
    maxWidth,
    width,
    spaceAfter
  };
  return (
    /*#__PURE__*/
    // @ts-expect-error As prop
    React.createElement(StyledGrid, (0, _extends2.default)({}, props, {
      smallMobile: smallMobile,
      "data-test": dataTest,
      as: as
    }), children)
  );
};
var _default = Grid;
exports.default = _default;